// A tiny event bus so non-React code (utilities, the API layer) can raise
// toasts without holding a React context. The ToastProvider listens for the
// TOAST_EVENT and renders whatever is emitted here.

export type ToastType = 'success' | 'error' | 'info';

export interface ToastInput {
  type: ToastType;
  message: string;
  /** Auto-dismiss after this many ms. Pass 0 to keep until dismissed. */
  duration?: number;
}

export const TOAST_EVENT = 'app:toast';

export function emitToast(input: ToastInput): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<ToastInput>(TOAST_EVENT, { detail: input }));
}
